import PropTypes from 'prop-types';
import { getEdgePath } from '../utils';
import { useCanvasRef } from '../NodeContextProvider';
import EdgeText from './EdgeText';

function SmoothStepEdge(props) {
  const { edge, edgeDiv, workflowId } = props;

  const canvasRef = useCanvasRef();

  const sourceHandle = canvasRef.current.querySelector(
    `.icp-workflow-handle.source[data-node-id="${edge.source}"]`,
  );
  const targetHandle = canvasRef.current.querySelector(
    `.icp-workflow-handle.target[data-node-id="${edge.target}"]`,
  );
  if (!sourceHandle || !targetHandle) {
    return null;
  }
  const sourceRect = sourceHandle.getBoundingClientRect();
  const targetRect = targetHandle.getBoundingClientRect();
  const edgeRect = edgeDiv.current.getBoundingClientRect();
  const sourceX = sourceRect.x - edgeRect.x + sourceRect.width / 2;
  const sourceY = sourceRect.y - edgeRect.y + sourceRect.height;
  const targetX = targetRect.x - edgeRect.x + targetRect.width / 2;
  const targetY = targetRect.y - edgeRect.y;
  const centerX = sourceX + (targetX - sourceX) / 2;
  const centerY = sourceY + (targetY - sourceY) / 2;

  const path = getEdgePath({ sourceX, sourceY, targetX, targetY });

  return (
    <g>
      <path d={path} markerEnd={`url(#${workflowId}__type=arrow)`} />
      <EdgeText x={centerX} y={centerY} label={edge.label} />
    </g>
  );
}

SmoothStepEdge.propTypes = {
  edge: PropTypes.shape({
    source: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    target: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  workflowId: PropTypes.string,
  edgeDiv: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
};

export default SmoothStepEdge;
